const EDUCATION_TYPE_OTHER = 5;
export default EDUCATION_TYPE_OTHER;
